export const getUrl = () => {
  const url = new URL(
    `${window.location.href}`
  );
  return url;
};
